import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useTreeItem } from "routes/schedule/lib/useTreeItem"

export function useIsRetired() {
    const { target } = useBoundContext()
    const item = useTreeItem(target?._id)
    return item?.$?.itemType === "retired"
}
